export default "__VITE_ASSET__d7cdbbd5__"